module.exports = __webpack_public_path__ + "static/media/career-img.c83dc045.jpg";